import type { IconData } from '@stacksjs/iconify-core'

export const thunderF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.708 4.968h1.789a1.5 1.5 0 0 1 1.378 2.09l-3.96 9.243a1.049 1.049 0 0 1-2.012-.413v-6.92L1.45 8.923A1.5 1.5 0 0 1 0 7.423V1.5A1.5 1.5 0 0 1 1.5 0h2.708a1.5 1.5 0 0 1 1.5 1.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default thunderF
